'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dBig$002dDecimal from "./java.math.-Big-Decimal.js";
import * as $j_java$002emath$002e$002dRounding$002dMode$0024 from "./java.math.-Rounding-Mode$.js";
var $p;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal($thiz, value) {
  var range = $thiz.jX.G;
  var $x_1 = $j_java$002elang$002e$002dObject.$uJ(value);
  range.ak($x_1.l, $x_1.h, $thiz.jX);
  var $x_2 = range;
  var unscaledVal_$_lo = $x_2.gq;
  var unscaledVal_$_hi = $x_2.gr;
  var minBD = $j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().rs(unscaledVal_$_lo, unscaledVal_$_hi);
  var $x_3 = range;
  var unscaledVal$1_$_lo = $x_3.fN;
  var unscaledVal$1_$_hi = $x_3.fO;
  var rangeBD = $j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().rs(unscaledVal$1_$_lo, unscaledVal$1_$_hi).CE(minBD).B2($j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().zF);
  var $x_4 = $j_java$002elang$002e$002dObject.$uJ(value);
  var unscaledVal$2_$_lo = $x_4.l;
  var unscaledVal$2_$_hi = $x_4.h;
  var valueBD = $j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().rs(unscaledVal$2_$_lo, unscaledVal$2_$_hi).CE(minBD);
  var fraction = valueBD.TA(rangeBD, 9, $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().rX);
  return ((fraction.Ol($j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().vg) === 0) ? $j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().vg : fraction.XQ());
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long($thiz, fraction) {
  var range = $thiz.jX.G;
  var $x_1 = range;
  var unscaledVal_$_lo = $x_1.gq;
  var unscaledVal_$_hi = $x_1.gr;
  var minBD = $j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().rs(unscaledVal_$_lo, unscaledVal_$_hi);
  var $x_2 = range;
  var unscaledVal$1_$_lo = $x_2.fN;
  var unscaledVal$1_$_hi = $x_2.fO;
  var rangeBD = $j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().rs(unscaledVal$1_$_lo, unscaledVal$1_$_hi).CE(minBD).B2($j_java$002emath$002e$002dBig$002dDecimal.$m_Ljava_math_BigDecimal$().zF);
  return $j_java$002emath$002e$002dBig$002dDecimal.$p_Ljava_math_BigDecimal__valueExact__I__J(fraction.W9(rangeBD).Qm(0, $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().rX).B2(minBD), 64);
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
  this.jX = null;
  this.lT = 0;
  this.vn = 0;
  this.s5 = false;
  this.jX = field;
  this.lT = minWidth;
  this.vn = maxWidth;
  this.s5 = decimalPoint;
  if ((!field.G.Vo())) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("Field must have a fixed set of values: " + field));
  }
  if (((minWidth >>> 0) > 9)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("Minimum width must be from 0 to 9 inclusive but was " + minWidth));
  }
  if (((((maxWidth - 1) | 0) >>> 0) > 8)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("Maximum width must be from 1 to 9 inclusive but was " + maxWidth));
  }
  if ((maxWidth < minWidth)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ((("Maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth));
  }
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = $p;
$p.hr = (function(context, buf) {
  var value = context.BF(this.jX);
  if ((value === null)) {
    return false;
  }
  var symbols = context.zO;
  var fraction = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal(this, value);
  if ((fraction.ab === 0)) {
    if ((this.lT > 0)) {
      if (this.s5) {
        var c = symbols.iM;
        var str = ("" + $j_java$002elang$002e$002dObject.$cToS(c));
        buf.r = (buf.r + str);
      }
      var i = 0;
      while ((i < this.lT)) {
        var c$1 = symbols.gU;
        var str$1 = ("" + $j_java$002elang$002e$002dObject.$cToS(c$1));
        buf.r = (buf.r + str$1);
        i = ((1 + i) | 0);
      }
    }
  } else {
    var a = fraction.ab;
    var b = this.lT;
    var a$1 = ((a > b) ? a : b);
    var b$1 = this.vn;
    var outputScale = ((a$1 < b$1) ? a$1 : b$1);
    fraction = fraction.Qm(outputScale, $j_java$002emath$002e$002dRounding$002dMode$0024.$m_Ljava_math_RoundingMode$().rX);
    var this$7 = fraction.Yb();
    var str$2 = this$7.substring(2);
    str$2 = symbols.Or(str$2);
    if (this.s5) {
      var c$2 = symbols.iM;
      var str$3 = ("" + $j_java$002elang$002e$002dObject.$cToS(c$2));
      buf.r = (buf.r + str$3);
    }
    var str$4 = str$2;
    buf.r = (("" + buf.r) + str$4);
  }
  return true;
});
$p.gG = (function(context, text, position) {
  var _position = position;
  var effectiveMin = (context.ej ? this.lT : 0);
  var effectiveMax = (context.ej ? this.vn : 9);
  var length = $j_java$002elang$002e$002dObject.$dp_length__I(text);
  if ((_position === length)) {
    return ((effectiveMin > 0) ? (~_position) : _position);
  }
  if (this.s5) {
    if (($j_java$002elang$002e$002dObject.$dp_charAt__I__C(text, _position) !== context.k0.iM)) {
      return ((effectiveMin > 0) ? (~_position) : _position);
    }
    _position = ((1 + _position) | 0);
  }
  var minEndPos = ((_position + effectiveMin) | 0);
  if ((minEndPos > length)) {
    return (~_position);
  }
  var a = ((_position + effectiveMax) | 0);
  var maxEndPos = ((a < length) ? a : length);
  var total = 0;
  var pos = _position;
  var break$1 = false;
  while (((!break$1) && (pos < maxEndPos))) {
    var ch = $j_java$002elang$002e$002dObject.$dp_charAt__I__C(text, pos);
    pos = ((1 + pos) | 0);
    var digit = context.k0.Os(ch);
    if ((digit < 0)) {
      if ((pos < minEndPos)) {
        return (~_position);
      }
      pos = ((pos - 1) | 0);
      break$1 = true;
    }
    if ((!break$1)) {
      total = ((Math.imul(10, total) + digit) | 0);
    }
  }
  var fraction = $j_java$002emath$002e$002dBig$002dDecimal.$ct_Ljava_math_BigDecimal__I__(new $j_java$002emath$002e$002dBig$002dDecimal.$c_Ljava_math_BigDecimal(), total).W7(((pos - _position) | 0));
  var value = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long(this, fraction);
  var $x_2 = this.jX;
  var $x_1 = $j_java$002elang$002e$002dObject.$uJ(value);
  return context.y8($x_2, $x_1.l, $x_1.h, _position, pos);
});
$p.b = (function() {
  var decimal = (this.s5 ? ",DecimalPoint" : "");
  return ((((((("Fraction(" + this.jX) + ",") + this.lT) + ",") + this.vn) + decimal) + ")");
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$FractionPrinterParser", ({
  lx: 1,
  av: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser };
